import React from 'react';
import { useSelector } from 'react-redux';
import { componentKey as PatientMedicationsComponentKey } from "../../../Patients/PatientDashboard/Medications/PatientMedicationsSlice";
import FaceSheetCard from '../../../Patients/PatientDashboard/Dashboard/FaceSheet/FaceSheetCard';
import Button from '../../../../components/common-components/button/Button';
import { BUTTON_VARIANTS } from '../../../../components/common-components/button/Constants';
import moment from 'moment';
import Icons from '../../../../components/icons/Icons';
import { MET_COLORS } from '../../../../libs/constant';

const MedicationsCard = () => {
    const { allCurrentMedicationsData } = useSelector((state) => state[PatientMedicationsComponentKey])

    const handleCopyClick = () => {
        let copiedText = '';
        allCurrentMedicationsData?.slice(0, 5).map(medication => {
            copiedText += `${medication.medicineName}\nStart Date: ${moment(medication.startDate).format('DD-MM-YYYY')}\n`
        })
        navigator.clipboard.writeText(copiedText);
    }

    return (
        <FaceSheetCard
            title="MEDICATIONS"
            iconbtn={
                allCurrentMedicationsData?.length ? <Button
                    variant={BUTTON_VARIANTS.TEXT}
                    customBtnClass="fs-14 font-bold text-met-primary"
                    style={{ height: '19px' }}
                    onClickCb={() => handleCopyClick()}
                >
                    <Icons iconName={'copyIcon'} color={MET_COLORS.PRIMARY}></Icons> Copy
                </Button> : ''
            }
            textColorClass={'text-met-primary'}
        >
            {allCurrentMedicationsData?.length ? allCurrentMedicationsData?.slice(0, 5).map((medication, index) => {
                return <div key={"face-sheet-card-" + index}>
                    <div className="mb-4">
                        <div className="flex items-center mb-1">
                            <div className={`fs-14`}>{`${medication.medicineName}`}</div>
                        </div>
                        <div className="text-gray-500 fs-14">{`Start Date: ${moment(medication.startDate).format('DD-MM-YYYY')}`}</div>
                    </div>
                </div>

            }) : <div className='fs-14 text-gray-500'>No data found</div>}
        </FaceSheetCard>
    );
};

export default MedicationsCard;
